<template>
  <div class="aside__subblock">
    <div class="aside__list">
      <div class="aside__item -full-">
        <div class="aside__list-title">Личные данные</div>
      </div>
      <div class="aside__item -full-">
        <UserInfo :value="user" @compare="compareUser"></UserInfo>
      </div>
      <div class="aside__item -full-">
        <div class="aside__list-title">Другие данные</div>
      </div>
      <div v-for="(course, idx) in coursesList" :key="idx" class="aside__item -full-">
        <div v-if="coursesList.length > 1" class="aside__item -full- position-relative">
          <Icon
            class="aside-options__icon aside__block-remove"
            icon="input-delete"
            @click="removeCourse(course)"
          ></Icon>
        </div>
        <CourseInfo :value="coursesList[idx]" :user="user.id" @compare="compare"></CourseInfo>
        <div class="aside__item -full-"></div>
      </div>
      <div class="aside__item -full-">
        <div class="aside-options__flex" @click="addCourse">
          <Icon class="aside-options__icon" icon="plus-circle"></Icon>Добавить курс
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import UserInfo from './Forms/UserInfo';
import CourseInfo from './Forms/CourseInfo';

export default {
  components: {
    UserInfo,
    CourseInfo
  },
  data: () => ({
    isUserCompare: false,
    user: {
      id: '',
      select: '',
      email: '',
      name: '',
      lastname: '',
      phone: '',
      city: '',
      site: '',
      niche: '',
      profitPerYear: '',
      profitPerLastYear: ''
    },
    coursesList: [
      {
        rowId: 1,
        courseId: '',
        tariffId: '',
        manager: '',
        tracker: '',
        // mentor: '',
        faculty: ''
      }
    ],
    count: 0
  }),
  computed: {
    ...mapState('users', {
      canSave: s => s.aside.meta.canSave,
      dataUser: s => s.aside.data.user,
      userCoruseList: s => s.data.userCoruseList
    })
  },
  watch: {
    userCoruseList() {
      if (this.userCoruseList) {
        this.coursesList = _.cloneDeep(this.userCoruseList).map(el => ({
          ...el,
          rowId: this.count++
        }));
      }
    }
  },
  mounted() {
    if (this.dataUser.id) {
      this.$store.dispatch('users/getUsersCourse', { id: this.dataUser.id });
      this.user = _.cloneDeep(this.dataUser);
      this.coursesList = _.cloneDeep(this.userCoruseList).map(el => ({
        ...el,
        rowId: this.count++
      }));
    }
  },
  destroyed() {
    this.$store.dispatch('usersGroupsUsers/setAsideData', {
      path: 'stagedUser',
      value: {}
    });
    this.$store.dispatch('usersGroupsUsers/setAsideMeta', {
      path: 'canSave',
      value: false
    });
    this.$store.dispatch('users/setAsideMeta', {
      path: 'canSave',
      value: false
    });
  },
  methods: {
    compare(v) {
      const index = this.coursesList.findIndex(el => el.id == v.id);
      this.coursesList[index] = { ...v };
      if (this.user.id || this.isUserCompare) {
        this.$store.dispatch('users/setAsideMeta', {
          path: 'canSave',
          value: true
        });
      }

      if (!v.courseId) {
        this.$store.dispatch('users/setAsideMeta', {
          path: 'canSave',
          value: true
        });
      }

      if (v.courseId && !v.tariffId) {
        this.$store.dispatch('users/setAsideMeta', {
          path: 'canSave',
          value: false
        });
      }

      this.$store.dispatch('users/setAsideData', {
        path: 'user',
        value: this.user
      });
      this.$store.dispatch('users/setData', {
        path: 'selectedCourse',
        value: this.coursesList
      });
    },
    compareUser(v) {
      this.user = { ...v };
      this.isUserCompare = true;
      this.$store.dispatch('users/setAsideMeta', {
        path: 'canSave',
        value: true
      });
      this.$store.dispatch('users/setAsideData', {
        path: 'user',
        value: this.user
      });
      this.$store.dispatch('users/setData', {
        path: 'selectedCourse',
        value: this.coursesList
      });
    },
    addCourse() {
      const max = Math.max.apply(
        null,
        this.coursesList.map(el => el.rowId)
      );
      this.coursesList = [
        ...this.coursesList,
        {
          rowId: +max + 1,
          courseId: '',
          tariffId: '',
          manager: '',
          tracker: ''
        }
      ];
    },
    removeCourse(course) {
      if (course.courseId) {
        this.$store.dispatch('users/setSelectedCourse', {
          id: course.courseId,
          remove: true
        });
      }

      this.coursesList = this.coursesList.filter(el => el.rowId !== course.rowId);
      this.$store.dispatch('users/setData', {
        path: 'selectedCourse',
        value: this.coursesList
      });
    }
  }
};
</script>
